import {BookingOccupancyContent} from "./booking/booking";


export const SignUpUrlKey = 'signUpUrl';
export const UtilizationKey = 'utilization';

export const DefaultSignUpUrl = 'http://localhost:5000/api/signup';

export const DefaultCodeLength = 7;

export interface UtilizationData {
    capacity: number;
    load: number;
}

export interface OccupancyContent {
    /** The booking information */
    booking?: BookingOccupancyContent;

    /** The datetime (ISO 8601) when this occupancy was released. */
    released?: string;

    /** The occupancy id of the backend */
    occupancyId?: number;
}